module.exports = __webpack_public_path__ + "static/media/Forecasting_Beijing01.e11e5bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forecast/Forecasting_Beijing01.jpg
// module id = 799
// module chunks = 0